import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { facebook, google, instragram, welcome1, welcome2, welcome3 } from "../../../assets/img";

const slides = [
  {
    id: 1,
    image: welcome1,
    title: "Welcome to Red Cloud Lottery",
    description: "Play smart and win big prizes every day",
  },
  {
    id: 2,
    image: welcome2,
    title: "Trusted & Secure",
    description: "Safe payments and transparent lottery system",
  },
  {
    id: 3,
    image: welcome3,
    title: "Start Winning Today",
    description: "Join now and try your luck instantly",
  },
];

const Login = () => {
  const navigate = useNavigate();
  const [index, setIndex] = useState(0);

  // Auto slider
  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % slides.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="login-page">

      {/* LEFT SLIDER */}
      <div className="left-side">
        <div className="welcome-container">
          <div
            className="slider"
            style={{ transform: `translateX(-${index * (100 / slides.length)}%)` }}
          >
            {slides.map((item) => (
              <div className="slide" key={item.id}>
                <img src={item.image} alt={item.title} />
                <h2>{item.title}</h2>
                <p>{item.description}</p>
              </div>
            ))}
          </div>

          <div className="dots">
            {slides.map((_, i) => (
              <span
                key={i}
                className={`dot ${index === i ? "active" : ""}`}
                onClick={() => setIndex(i)}
              />
            ))}
          </div>
        </div>
      </div>
      <div className="right-side">
        <div className="login-card">
          <h2 className="title">Welcome 🎉</h2>
          <p className="subtitle">Login with your mobile number</p>

          <div className="mobile-input-container">
            <div className="country-code-box">
              <select>
                <option value="+91">🇮🇳 +91</option>
                <option value="+1">🇺🇸 +1</option>
                <option value="+44">🇬🇧 +44</option>
                <option value="+61">🇦🇺 +61</option>
              </select>
            </div>
            <input type="tel" required placeholder="Enter mobile number" />
          </div>
          <button
            className="login-btn"
            onClick={() => navigate("/home")}
          >
            Continue
          </button>
          <div className="divider"><span>OR</span></div>
          <div className="social-login d-flex ac-jc">
            <img src={google} alt="Google" />
            <img src={facebook} alt="Facebook" />
            <img src={instragram} alt="Instagram" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
